var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card-title',{staticClass:"justify-center this-header"},[_vm._v(" "+_vm._s(_vm.header)+" ")]),_c('v-subheader',{staticClass:"justify-center height-24"},[_vm._v(" "+_vm._s(_vm.subheader)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }